import HelperFunctions from '@/assets/HelperFunctions.js'

const MapFunctions = {
  calcOffset: function(center, map){
  	var offset = (map.getSize().x*0.25);

  	if(!HelperFunctions.isMobile){
  		var targetPoint = map.project(center, map.getZoom()).subtract([0, 0]);
  		return map.unproject(targetPoint);
  	}

  	var targetPoint = map.project(center, map.getZoom()).subtract([0, -offset]);

  	return map.unproject(targetPoint);
  },
  determineArrow: function(str) {
    if(str.indexOf('lige ud') != -1) {
      return '<span class="material-icons routeplan-details-arrow">arrow_upward</span>';
    }
    else if(str.indexOf('venstre') != -1) {
      return '<span class="routeplan-details-arrow material-icons" style="-webkit-transform: rotate(180deg);\
                                        -ms-transform: rotate(180deg);\
                                        transform: rotate(180deg);">subdirectory_arrow_right</span>';
    }
    else if(str.indexOf('højre') != -1) {
      return '<span class="routeplan-details-arrow material-icons" style="-webkit-transform: rotate(180deg);\
                                        -ms-transform: rotate(180deg);\
                                        transform: rotate(180deg);">subdirectory_arrow_left</span>';
    }
    else if(str.indexOf('ankommet') != -1) {
      return '<span class="material-icons routeplan-details-arrow">flag</span>';
    }
    else if(str.indexOf('Start på') != -1) {
      return '<span class="material-icons routeplan-details-arrow">location_on</span>';
    }
    else if(str.indexOf('Tag udkørsel nr.') != -1) {
      return '<span class="routeplan-details-arrow"><div class="roundabout"></div></span>';
    }
    else if(str.indexOf('u-vending') != -1) {
      return '<span class="material-icons routeplan-details-arrow">arrow_downward</span>';
    }

    return '';
  },
};

export default MapFunctions;
